import api from './openAjax'
import { getSign } from './commonSign';

export const getSumJsPay = params => api.openPost('/open/jspay', getSign(params)) // 聚合支付

export const getOrderDetail = params => api.openPost('/open/pay/query', getSign(params)) // 聚合支付